import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20floral%20workshop%20scene%20with%20artisan%20hands%20arranging%20fresh%20flowers%20on%20a%20rustic%20wooden%20table%2C%20warm%20natural%20light%20from%20large%20windows%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20peonies%20roses%20and%20eucalyptus%20sprigs%2C%20editorial%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20warm%20morning%20atmosphere&width=1600&height=900&seq=hero-main-001&orientation=landscape"
          alt="Florale Manufaktur – Hände bei der floristischen Arbeit mit frischen Blumen"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pt-20">
        {/* Headline */}
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 max-w-4xl mx-auto leading-tight drop-shadow-lg">
          Floristik, die von Herzen kommt.
        </h1>

        {/* Subline */}
        <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed drop-shadow-md">
          Individuelle Floristik mit Tradition – persönlich gestaltet für die besonderen Momente des Lebens.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 md:mb-14">
          <Link
            to="/strauss-geschenk"
            className="inline-flex items-center justify-center px-8 py-3.5 bg-background-50 text-foreground-950 rounded-md text-sm font-medium hover:bg-white transition-colors whitespace-nowrap shadow-lg"
          >
            Floristik entdecken
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-white/80 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            Persönlich beraten lassen
          </Link>
        </div>

        {/* Fleurop CTA */}
        <div className="mb-10 md:mb-14">
          <a
            href="https://www.fleurop.de/partnerfloristen/fleurop-filialen/26789-leer/florale-manufaktur-blumen-stoehr-gmbh-heisfelder-str-105"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500/90 backdrop-blur-sm text-white rounded-md text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap shadow-lg"
          >
            <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center"></i>
            Blumen online über Fleurop versenden
          </a>
        </div>

        {/* Trust Elements */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {/* Google Rating */}
          <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2">
            <div className="flex items-center gap-0.5">
              {[1, 2, 3, 4].map((i) => (
                <i key={i} className="ri-star-fill w-4 h-4 flex items-center justify-center text-yellow-400 text-sm"></i>
              ))}
              <i className="ri-star-half-fill w-4 h-4 flex items-center justify-center text-yellow-400 text-sm"></i>
            </div>
            <span className="text-white text-sm font-medium">4,6/5</span>
            <span className="text-white/70 text-xs">192 Google-Bewertungen</span>
          </div>

          {/* Fleurop Badge */}
          <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2">
            <i className="ri-award-line w-4 h-4 flex items-center justify-center text-accent-300 text-sm"></i>
            <span className="text-white text-sm font-medium">Fleurop 5-Sterne-Florist</span>
          </div>

          {/* Family Business */}
          <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2">
            <i className="ri-heart-3-line w-4 h-4 flex items-center justify-center text-secondary-300 text-sm"></i>
            <span className="text-white text-sm">Familienbetrieb seit über 100 Jahren</span>
          </div>
        </div>
      </div>
    </section>
  );
}